import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Member } from 'src/app/model/member.model';
import { SaleM, Sales } from 'src/app/model/sales.model';
import { TranhistoryService } from './tranhistory.service';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { Scroller } from 'primeng/scroller';

@Component({
  selector: 'app-tranhistory',
  templateUrl: './tranhistory.component.html',
  styleUrls: ['./tranhistory.component.css'],
})
export class TranhistoryComponent implements OnInit {
  @ViewChild('sc') sc!: Scroller;
  CompanyID: string;
  UserID: string;
  Liff_ID: string;
  UserName: string;
  LoginUser: Member;
  editModel: Sales[] = []; //預覽表單
  showModel: Sales = new Sales();
  Balance: number;
  isOptionLoading = false;
  showDs = false;
  subscribes: Subscription = new Subscription();
  isShow = false;

  isLoading = false;
  constructor(
    private route: ActivatedRoute,
    private TranhistoryService: TranhistoryService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    var that = this;
    // 取得querystring param
    var query = this.route.queryParams.subscribe((value) => {
      this.CompanyID = value['CompanyID'];
      this.UserID = value['UserID'];
      this.Liff_ID = value['Liff_ID'];
    });

    var currentUser = this.authenticationService.currentMember.subscribe(
      (member) => {
        this.LoginUser = member;
      }
    );

    this.subscribes.add(query);
    this.subscribes.add(currentUser);
    this.subscription();
  }

  //#region  初始化
  subscription() {
    this.isOptionLoading = true;
    var defaultValue = this.TranhistoryService.GetTranHistory(
      this.CompanyID,
      this.UserID
    ).subscribe((res) => this.GetTranHistorySucceed(res));

    this.subscribes.add(defaultValue);
  }
  //#endregion

  //#region 資料處理
  GetTranHistorySucceed(res: any) {
    if (!!res.ErrorFlag == true && res.ErrorFlag == '1') {
      Swal.fire({
        icon: 'error',
        title: res.ErrorMsg,
      });
      this.isOptionLoading = false;
      return;
    } else {
      this.editModel = []; 
      if (!!res && res.length > 0) {
        res.forEach((el: any) => {
          var model = new Sales();
          model.SaleM = el['SaleM'] ?? new SaleM();
          model.SaleM.Pays = el['SaleM']?.Pays ?? [];
          model.SaleDs = el['SaleDs'] ?? [];
          this.editModel.push(model);
        });
        this.showModel = new Sales();
        this.showModel.SaleM = new SaleM();
      }

      this.isOptionLoading = false;
    }
  }
  ShowMoreHistorySucceed(res: any) {
    if (!!res.ErrorFlag == true && res.ErrorFlag == '1') {
      Swal.fire({
        icon: 'error',
        title: res.ErrorMsg,
      });
      this.isOptionLoading = false;
      return;
    } else {
      this.editModel = [];
      if (!!res && res.length > 0) {
        res.forEach((el: any) => {
          var model = new Sales();
          model.SaleM = el['SaleM'] ?? new SaleM();
          model.SaleM.Pays = el['SaleM']?.Pays ?? [];
          model.SaleDs = el['SaleDs'] ?? [];
          this.editModel.push(model);
        });
        this.showModel = new Sales();
        this.showModel.SaleM = new SaleM();
        this.showModel.SaleDs = [];
      }

      this.isLoading = false;
    }
  }
  ShowMore() {
    this.isLoading = true;
    this.isShow = true;
    var moreValue = this.TranhistoryService.ShowMoreHistory(
      this.CompanyID,
      this.UserID
    ).subscribe((res) => this.ShowMoreHistorySucceed(res));

    this.subscribes.add(moreValue);
  }

  GetDetails(saleNo: string) {
    if (!!saleNo) {
      this.showModel = new Sales();
      const theSale = this.editModel.find((s) => s.SaleM.SaleNo == saleNo);
      if (!!theSale) {
        this.showModel.SaleM = new SaleM();
        this.showModel.SaleM = theSale.SaleM ?? new SaleM();
        this.showModel.SaleM.Pays = theSale.SaleM ?.Pays?? [];
        this.showModel.SaleDs = [];
        theSale.SaleDs.forEach((el) => {
          this.showModel.SaleDs.push(el);
        });
        this.showDs = true;
      } else {
        Swal.fire({
          icon: 'error',
          title: '資料錯誤，找不到該筆消費紀錄',
        });
      }
      this.isLoading = false;
    }
  }
  //#endregion

  //#region 資料處理
  reset(){
    this.sc.scrollToIndex(0, 'smooth');
  }
  //#endregion
  ngOnDestroy() {
    this.subscribes.unsubscribe();
  }
}
